import React from 'react';
import s from './style.css';
const SettingsItem = ({ icon, text, danger, onClick }) => {
    return (React.createElement("div", { className: s.item, role: 'button', tabIndex: 0, onClick: (e) => {
            e.stopPropagation();
            onClick();
        }, onKeyDown: (e) => {
            if (e.key === 'Enter' || e.key === ' ') {
                e.stopPropagation();
                onClick();
            }
        } },
        icon,
        React.createElement("p", { className: s.text, style: { color: danger ? 'red' : '#0F0F28' } }, text)));
};
export default SettingsItem;
